
import { motion, AnimatePresence, useAnimate, delay } from "motion/react"
import { useEffect, useRef, useState } from "react";
import { Link } from "react-router";
import { useTonConnectModal, useTonConnectUI, useTonWallet } from '@tonconnect/ui-react';
import { usePlatform } from "../utils/telegram";
import { shareURL, retrieveLaunchParams } from '@telegram-apps/sdk';
import { useQuery, useQueryClient, useIsFetching } from '@tanstack/react-query'
import { comment } from '@ton/core';
import { useApi } from '../utils/api'
import { toUserFriendlyAddress } from '@tonconnect/sdk';

function Overlay() {
    const [scope, animate] = useAnimate();
    const [scopeG, animateG] = useAnimate();
    useEffect(_ => {
        animate([
            [scope.current, { opacity: 1, transform: `scale(1)` }, { duration: 0.5 }],
            [scope.current, { fontWeight: 1000, transform: `scale(1) translateX(0%)` }, { duration: 1}],
            [scope.current, { transform: `scale(1) translateX(100%)`, opacity: 0 }, { duration: 1, delay: 0.5 }],
        ])
        animateG([
            [scopeG.current, { opacity: 0, display: `none` }, { duration: 1, delay: 2 }],
        ])
    }, []);
    return (
        <motion.div
            layout
            ref={scopeG}
            // whileInView={{opacity: 0 }}
            initial={{opacity: 1, display: `flex`}}
            // transition={{ duration: 1, delay: 2 }}
            className="absolute top-0 z-50 w-full h-full max-w-[70vh] flex flex-col justify-center items-center overflow-hidden"
        >
            <motion.svg
                layout
                whileInView={{transform: `scale(1) translateX(-100%)`, }}
                initial={{transform: `scale(1) translateX(100%)`}}
                transition={{ duration: 1, delay: 2 }}
                viewBox="0 0 56 18"
                className="font-extrabold italic w-full text-[0.75rem]"
            >
                <text x="0" y="15" style={{stroke: `black`, strokeWidth: 0.5, fill: `transparent`, opacity: 0.6 }}>REWARDS</text>
            </motion.svg>
            <motion.svg
                ref={scope}
                layout
                initial={{opacity: 0, transform: `scale(5)`, fontWeight: 500 }}
                viewBox="0 0 56 18"
                className="text-black font-extrabold italic w-full"
            >
                <text x="5" y="15">Swipe</text>
            </motion.svg>
            <motion.svg
                layout
                whileInView={{transform: `scale(1) translateX(-100%)`, }}
                initial={{transform: `scale(1) translateX(100%)`}}
                transition={{ duration: 1, delay: 2 }}
                viewBox="0 0 56 18"
                className="font-extrabold italic w-full text-[0.75rem]"
            >
                <text x="0" y="15" style={{stroke: `black`, strokeWidth: 0.5, fill: `transparent`, opacity: 0.6 }}>REWARDS</text>
            </motion.svg>
        </motion.div>
    )
}

function Timer({ upTo }) {
    const ref = useRef(null);
    
    useEffect(() => {
      if (ref.current) {
        const interval = setInterval(() => {
          ref.current.innerHTML = calculateTimeRemaining()
        }, 70);
        return () => {
          clearInterval(interval);
        };
      }
      
  
    }, [ref]);
  
    
    const calculateTimeRemaining = () => {
      if (!upTo) return "00:00:00.000";
      
      const now = new Date();
      const target = new Date(upTo);
      const diff = Math.max(0, target - now);
      
      const hours = Math.floor(diff / (1000 * 60 * 60));
      const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((diff % (1000 * 60)) / 1000);
      const milliseconds = diff % 1000;
      
      return `<b>${hours.toString().padStart(2, '0')}</b>:<b>${minutes.toString().padStart(2, '0')}</b>:<b>${seconds.toString().padStart(2, '0')}</b>.${milliseconds.toString().padStart(3, '0')}`;
    };
    
    return (
      <span className="text-[#95FF00] font-[1000] italic text-xs timer" ref={ref}></span>
    );
  }
  

function RewardListItem(props) {
    return (
        <motion.div initial={{opacity: 0, transform: 'scale(1.2)'}} whileInView={{opacity: 1, transform: 'scale(1)'}} transition={props.transition} className="border-0 w-full px-4 py-3 text-[#95FF00] font-[700] italic text-xl flex-row flex justify-between items-center">
            {props.children}
        </motion.div>
    )
}


function RewardTab({ accountData }) {
    const platform = usePlatform();
    let formatter = Intl.NumberFormat('en', { notation: 'compact' });

    return (
        <motion.div
            layout
            whileInView={{ opacity: 1 }}
            initial={{ opacity: 0 }}
            transition={{ duration: 0.5, delay: 2.5 }}
            className="relative z-0 w-full h-full max-w-[70vh] flex flex-col gap-1 box-border justify-between items-center overflow-hidden"
        >
            <div>
                <div className="relative w-full h-[30vh] bg-[#95FF00] box-border flex flex-col justify-end p-10 py-6">
                    <span className="text-black/70 font-[700] italic text-2xl">Balance</span>
                    <h1 className="text-black font-[900] italic text-[3rem] leading-[3.5rem] w-full flex flex-row justify-between">
                        <span>{formatter.format(accountData.balance)} <span className="text-2xl">PTS</span></span>
                        <span className="opacity-70">${formatter.format(accountData.balance_usd)}</span>
                    </h1>
                </div>
                <div className="w-0 h-0 border-arrow"></div>
            </div>
            <div className="p-8 flex w-full flex-col gap-0 py-0">
                <RewardListItem transition={{ duration: 1.0, delay: 2.7 }}>
                    <span>Share</span>
                    <span>+1000</span>
                </RewardListItem>
                <motion.hr transition={{ duration: 1.0, delay: 2.7 }} initial={{opacity: 0, transform: 'scale(1.2)'}} whileInView={{opacity: 1, transform: 'scale(1)'}} className="h-[1.5px] bg-[#95FF00] w-full border-0" />
                <RewardListItem transition={{ duration: 1.0, delay: 3.2 }}>
                    <span>Watch content</span>
                    <span>+10</span>
                </RewardListItem>
                <motion.hr transition={{ duration: 1.0, delay: 3.2 }} initial={{opacity: 0, transform: 'scale(1.2)'}} whileInView={{opacity: 1, transform: 'scale(1)'}} className="h-[1.5px] bg-[#95FF00] w-full border-0" />
                <RewardListItem transition={{ duration: 1.0, delay: 3.7 }}>
                    <span>Upload new videos</span>
                    <span>+500</span>
                </RewardListItem>
                <motion.hr transition={{ duration: 1.0, delay: 3.7 }} initial={{opacity: 0, transform: 'scale(1.2)'}} whileInView={{opacity: 1, transform: 'scale(1)'}} className="h-[1.5px] bg-[#95FF00] w-full border-0" />
                <RewardListItem transition={{ duration: 1.0, delay: 4.2 }}>
                    <span>Daily login</span>
                    <Timer upTo={new Date(accountData.next_claim)} />
                </RewardListItem>
                <motion.hr transition={{ duration: 1.0, delay: 4.2 }} initial={{opacity: 0, transform: 'scale(1.2)'}} whileInView={{opacity: 1, transform: 'scale(1)'}} className="h-[1.5px] bg-[#95FF00] w-full border-0" />
                <RewardListItem transition={{ duration: 1.0, delay: 4.7 }}>
                    <span>Every 10th referral</span>
                    <span>$1</span>
                </RewardListItem>

            </div>
            <div className="flex flex-col w-full gap-6 px-8 pb-8">
                <motion.div onClick={_ => {
                    shareURL(`https://t.me/appswipe_bot/rewards?startapp=ref_${accountData.ref}`, `Start Earning with Swipe!\nI have ${accountData.invite_limit - accountData.invited} invites left.`);
                    try {
                        if (navigator.clipboard) {
                            navigator.clipboard.writeText(`https://t.me/appswipe_bot/rewards?startapp=ref_${accountData.ref}`);
                        }
                    } catch (e) {
                        console.error(e);
                    }
                }} initial={{opacity: 0, transform: 'scale(1.2)'}} whileInView={{opacity: 1, transform: 'scale(1)'}} transition={{ duration: 1.0, delay: 5.2 }} className="cursor-pointer border-[#95FF00] animate-[dance2_1s_alternate_infinite_ease-in-out] border-[1.5px] w-full px-4 py-4 text-[#95FF00] font-[900] italic text-xl flex-row flex justify-between items-center">
                    <div className="flex flex-col">
                        <span>Invite Referrals</span>
                        <span className="text-sm font-[700]">Get 50% earnings</span>
                    </div>
                    <div className="fill-[#95FF00] flex flex-row items-center h-full gap-2">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="m14.014 17l-.006 2.003c-.001.47-.002.705-.149.851s-.382.146-.854.146h-3.01c-3.78 0-5.67 0-6.845-1.172c-.81-.806-1.061-1.951-1.14-3.817c-.015-.37-.023-.556.046-.679c.07-.123.345-.277.897-.586a1.999 1.999 0 0 0 0-3.492c-.552-.308-.828-.463-.897-.586s-.061-.308-.045-.679c.078-1.866.33-3.01 1.139-3.817C4.324 4 6.214 4 9.995 4h3.51a.5.5 0 0 1 .501.499L14.014 7c0 .552.449 1 1.002 1v2c-.553 0-1.002.448-1.002 1v2c0 .552.449 1 1.002 1v2c-.553 0-1.002.448-1.002 1" clip-rule="evenodd"/><path fill="currentColor" d="M15.017 16c.553 0 1.002.448 1.002 1v1.976c0 .482 0 .723.155.87c.154.148.39.138.863.118c1.863-.079 3.007-.331 3.814-1.136c.809-.806 1.06-1.952 1.139-3.818c.015-.37.023-.555-.046-.678c-.069-.124-.345-.278-.897-.586a1.999 1.999 0 0 1 0-3.492c.552-.309.828-.463.897-.586c.07-.124.061-.309.046-.679c-.079-1.866-.33-3.011-1.14-3.818c-.877-.875-2.154-1.096-4.322-1.152a.497.497 0 0 0-.509.497V7c0 .552-.449 1-1.002 1v2a1 1 0 0 1 1.002 1v2c0 .552-.449 1-1.002 1z" opacity=".5"/></svg>
                        <span>{accountData.invited}/{accountData.invite_limit}</span>
                    </div>
                </motion.div>
                <motion.div initial={{opacity: 0, transform: 'scale(1.2)'}} whileInView={{opacity: 1, transform: 'scale(1)'}} transition={{ duration: 1.0, delay: 5.2 }} className="w-full">
                    <Link to="/" className="block text-center animate-[dance_0.7s_alternate_infinite_ease-in-out] p-4 w-full bg-[#95FF00] font-[900] italic text-xl">Open App</Link>
                </motion.div>
            </div>

        </motion.div>
    )
}

window.initialLaunched = false;

function TabInitial(props) {
    const qc = useQueryClient();
    const params = retrieveLaunchParams();
    const [tonConnectUI, setOptions] = useTonConnectUI();
    const { state, open, close } = useTonConnectModal();
    const wallet = useTonWallet();
    const targetVerifyAddress = "UQB0bZM-8qfhVC1XqpACSoOpKnLXHB_vDerk5Ij3584zs9XD";
    const accountData = qc.getQueryData(['account']);
    const {verifyWallet} = useApi();
    

    const validate = _ => {
        verifyWallet(toUserFriendlyAddress(wallet.account.address)).then(_ => {
            qc.refetchQueries(['account']).then(_ => {});
        }).finally(_ => {
            if (!window.initialLaunched) {
                window.initialLaunched = true;
                tonConnectUI.connector.disconnect().then(_ => {});
            }
        })
    }

    useEffect(_ => {
        if (params && params.initData) {
            tonConnectUI.setConnectRequestParameters({
                state: 'ready',
                // value: {
                //     tonProof: params.initData.user.id.toString(),
                // }
            });
        }
    }, [params]);

    useEffect(_ => {
        if (wallet) {
            validate();
        }
    }, [wallet]);

    if (!accountData) return null;

    const myTransaction = {
        // validUntil: Math.floor(Date.now() / 1000) + 300,
        network: "-239",
        messages: [
            {
                address: targetVerifyAddress,
                amount: "50000000",
                payload: comment(accountData.proof).toBoc().toString('base64'),
            },
        ]
    };
    const sign = _ => {
        tonConnectUI.sendTransaction(myTransaction).then((r) => {
            setTimeout(validate, 2000);
        })
    };

    const isWalletConnected = wallet && wallet.account;
    const step = isWalletConnected ? 2 : 1;
    const text = isWalletConnected ? "Sign Transaction" : "Connect TON";
    const action = isWalletConnected ? sign : open;

    return (
        <motion.div
            layout
            whileInView={{ opacity: 1 }}
            initial={{ opacity: 0 }}
            transition={{ duration: 0.5, delay: 2.5 }}
            className="relative z-0 w-full h-full max-w-[70vh] flex flex-col gap-1 box-border justify-between items-center overflow-hidden"
        >
            <div className="flex flex-col p-8 w-full h-full justify-between">
                <div className="w-full py-12 flex flex-col gap-2 flex-grow justify-center">
                    <h1 className="text-[#95FF00] font-[1000] italic text-[2.5rem]">Register<br />{accountData.balance_usd > 0 ? `Get $${accountData.balance_usd} Bonus` : `Earn Rewards`}</h1>
                    <span className="text-[#95FF00] font-[700] italic text-2xl">Step {step}/2</span>
                </div>
                <motion.div initial={{opacity: 0, transform: 'scale(1.2)'}} whileInView={{opacity: 1, transform: 'scale(1)'}} transition={{ duration: 1.0, delay: 0 }} className="flex flex-col w-full items-center gap-4">
                    <span className="text-[#95FF00] font-[700] italic text-md">You have <Timer upTo={new Date(accountData.reward_locks)} /></span>
                    <button onClick={action} className="block text-center animate-[dance_0.7s_alternate_infinite_ease-in-out] p-4 w-full bg-[#95FF00] font-[900] italic text-xl">{text}</button>
                </motion.div>
            </div>

        </motion.div>
    )
}

function TabSwitch() {
    const qc = useQueryClient();
    const isFetchingAccount = useIsFetching({ queryKey: ['account'] })
    const accountData = qc.getQueryData(['account']);

    if (!accountData || !accountData.rewards_unlocked) return <TabLocked />
    if (accountData.wallet === "") return <TabInitial />

    return <RewardTab accountData={accountData} />
}

function TabLocked(props) {
    return (
        <motion.div
            layout
            whileInView={{ opacity: 1 }}
            initial={{ opacity: 0 }}
            transition={{ duration: 0.5, delay: 2.5 }}
            className="relative z-0 w-full h-full max-w-[70vh] flex flex-col gap-1 box-border justify-between items-center overflow-hidden"
        >
            <div className="flex flex-col p-8 w-full h-full justify-between">
                <div className="w-full py-12 flex flex-col gap-2 flex-grow justify-center">
                    <h1 className="text-[#95FF00] font-[1000] italic text-[2.5rem]">Swipe Rewards</h1>
                    <span className="text-[#95FF00] font-[700] italic text-2xl">Referral code expired or invalid</span>
                </div>
            </div>

        </motion.div>
    )
}

function Rewards(props) {
    return (
        <motion.div
            layout
            whileInView={{background: `#000000` }}
            initial={{background: `#95FF00`}}
            transition={{ duration: 0.5, delay: 2.5 }}
            className="relative w-[100vw] h-[100vh] bg-[#95FF00] flex justify-center items-center"
        >
            <Overlay />
            <TabSwitch />
        </motion.div>
    )
}


export default Rewards;